import { Card, Col, Modal, Row } from 'antd'
import * as React from 'react'
import { withRouter } from 'react-router'

import { IDocumentiService } from '../../services/DocumentiService'
import IoCContainer from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { AllDocType, CategorieDocumentoResponseModel, TipoDocumento, TipoDocumentoModel } from '../../model/DocumentiModels'

import { NavigationBar } from '../NavigationBar'
import folders from './../../content/folders.svg'
import info from './../../content/info_grey.svg'
import inoltrato from './../../content/inoltrato.svg'

class PageCategoriaDocumentiCmp extends React.Component<any, CategorieDocumentoResponseModel> {

    private documentiService: IDocumentiService

    constructor(props) {
        super(props)
        this.state = new CategorieDocumentoResponseModel()
        this.documentiService = IoCContainer.get(SERVICE_IDENTIFIER.DOCUMENTI_SERVICE)

        document.title = "Documenti";
    }

    async componentDidMount() {
        var res = await this.documentiService.GetCategorieDocumenti(this.props.match.params.id)
        if (res.IsValid === true)
            this.setState(res)
    }

    go = (tipoDocumento: TipoDocumento) => {
        if (tipoDocumento != TipoDocumento.assicurativo)
            this.props.history.push('/CaricaDoc/' + this.props.match.params.id + '/' + TipoDocumento[tipoDocumento])
        else
            this.props.history.push('/CaricaDocAmministrativi/' + this.props.match.params.id + '/assicurativo' )
    }

    onHelpClick = () => {
        Modal.info({
            width: 800,
            title: "Allega tutti i documenti richiesti ed inviali al tuo specialista mutui",
            content: <>Potrai allegare documenti solamente nei formati.pdf,.jpg,.png<br />
                Ti manderemo una notifica appena è disponibile l'esito della verifica.<br />
                Ti ricordiamo che la valutazione avverrà all'invio di tutti i documenti richiesti. Ecco alcuni consigli per rendere i tuoi documenti più chiari e leggibili:<br />
                <ul>
                    <li>Fai attenzione alle fotocopie troppo scure: i documenti devono essere leggibili in tutte le loro parti;</li>
                    <li>Non usare evidenziatori o pennarelli poiché possono rendere difficile la lettura dei documenti.</li>
                </ul>
            </>
        })
    }

    renderTitle = () => {
        return <span>Allega Documenti&nbsp;<a onClick={() => this.onHelpClick()} tabIndex={0}><img src={info} style={{ width: '18px' }} /></a></span>
    }

    renderStato = (props: TipoDocumentoModel) => {
        if (props.Tipo == TipoDocumento.assicurativo || props.Tipo == TipoDocumento.ape) return <Row><Col> <br/></Col></Row>;;
        if (props.State == null) return <Row><Col><span>Documenti caricati</span><span> {props.Count}/{props.Total}</span></Col></Row>;
        if (props.State == AllDocType.Inviati) return <Row><Col><span>In verifica </span><img src={inoltrato} style={{ width: '14px' }} /></Col></Row>;
        if (props.State == AllDocType.Verificato) return <Row><Col><span>Verificati </span></Col></Row>;

        return <Row><Col><span>Documenti caricati</span><span> {props.Count}/{props.Total}</span></Col></Row>;
    }

    renderCategoria = (props: TipoDocumentoModel) => {
        return (
            <Col key={props.Id} xl={7} md={10} xs={18}>
                <a onClick={() => this.go(props.Tipo)} role="button" tabIndex={0}>
                    <Card>
                        <Row>
                            <Col span="4"><img src={folders} /></Col>
                            <Col span="18"><h2 className="Bold20Credem400">{props.Description}</h2></Col>
                        </Row>

                        {this.renderStato(props)}

                        <Row justify="end"><Col>Vai</Col></Row>
                    </Card>
                </a>
            </Col>
        )

    }

    renderCategorie = () => {
        if (this.state.Categorie == null) return
        return this.state.Categorie.map(this.renderCategoria)
    }

    render() {
        return (
            <>
                <NavigationBar title={this.renderTitle()} />
                <Row justify="center" gutter={[30, 30]}>
                    {this.renderCategorie()}
                </Row>
            </>
        )
    }
}

export const PageCategoriaDocumenti = withRouter(PageCategoriaDocumentiCmp)
